import { ActionSubTypes } from '../../../../actions/ActionSubTypes';
import ApiBaseReducer from '../../../core/ApiBaseReducer';
import pList from '../../../../api/models/pList';
import { rEmlakVergiUstbilgiDetay } from '../../../../api/models/.catalog';
import { DefaultInputDataStateModel, IInputDataStateModel } from '../../../../models/StateModels';

export default ApiBaseReducer<pList, IInputDataStateModel<pList, rEmlakVergiUstbilgiDetay>, rEmlakVergiUstbilgiDetay>(
  ActionSubTypes.API_OYAKEMLAKVERGILERIDETAYTOPLAMDEGER,
  DefaultInputDataStateModel<pList, rEmlakVergiUstbilgiDetay>()
);
